// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  --afi-file-input-width: auto;
  --afi-file-input-max-width: 450px;
  --afi-file-input-flex-basis: auto;
  --afi-file-input-padding-left: 0;
  --afi-drop-area-width: 450px;
  --afi-drop-area-min-height: auto;
  --afi-drop-area-margin-top: 0.5rem;
  --afi-mobile-drop-area-width: 100%;
  --afi-file-list-display: block;
  --afi-file-list-margin-top: 10px;
  --afi-transfer-file-width: 450px;
  --afi-transfer-file-margin-top: 0;
  --afi-transfer-file-with-preview: 92%;
  --afi-transfer-file-button-display: block;
  --afi-transfer-file-button-align-items: normal;
  --afi-transfer-file-button-justify-content: normal;
  --afi-form-group-margin-bottom: 1rem;
}

.form-group.row.form-row {
  margin-bottom: var(--afi-form-group-margin-bottom);
}

.form-group.row {
  margin-left: 0;
  margin-right: 0;
}

.file-input {
  width: var(--afi-file-input-width);
  max-width: var(--afi-file-input-max-width);
  padding-left: var(--afi-file-input-padding-left);
}

.file-input.col-sm-10:only-child {
  flex: 0 0 100%;
  max-width: 100%;
}

.drop-area.file-drop-area {
  width: var(--afi-drop-area-width) !important;
  min-height: var(--afi-drop-area-min-height);
  margin-top: var(--afi-drop-area-margin-top) !important;
}

@media screen and (max-width: 990px) {
  .drop-area.file-drop-area {
    width: 100% !important;
  }
}
@media screen and (max-width: 650px) {
  .drop-area.file-drop-area {
    width: var(--afi-mobile-drop-area-width) !important;
    flex-direction: column;
    gap: 20px;
  }
}
@media screen and (max-width: 576px) {
  .drop-area.file-drop-area {
    max-width: 450px;
    min-width: 220px;
  }
}
.file-list {
  margin-top: var(--afi-file-list-margin-top);
  display: var(--afi-file-list-display);
}

.transfer-file {
  width: var(--afi-transfer-file-width);
  margin-top: var(--afi-transfer-file-margin-top);
}

.file-input .file-drop-area {
  position: relative;
  display: flex;
  align-items: center;
  width: 450px;
  max-width: 100%;
  padding: 20px;
  border: 2px dotted rgb(164, 164, 164);
  border-radius: 3px;
  transition: 0.2s;
  margin-top: 0.5rem;
}
.file-input .file-message {
  font-size: small;
  font-weight: 300;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-input .file-input {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  opacity: 0;
}

.file-list {
  width: 100%;
  margin-top: 15px;
}

.transfer-file {
  display: flex;
  justify-content: space-between;
  width: var(--afi-transfer-file-width);
  max-width: 100%;
  box-sizing: border-box;
  padding-left: 15px;
  align-items: center;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  margin-bottom: 5px;
}
.transfer-file p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.transfer-file:nth-child(odd) {
  background: #f1f1f1;
}
.transfer-file button {
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0;
  background: white;
  font-size: 16px;
  border: 1px solid grey;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: var(--afi-transfer-file-button-display);
  align-items: var(--afi-transfer-file-button-align-items);
  justify-content: var(--afi-transfer-file-button-justify-content);
}
.transfer-file button:hover {
  background: grey;
  color: white;
}

.hide-div {
  display: none !important;
}

.with-preview {
  width: var(--afi-transfer-file-with-preview);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
